module.exports = __webpack_public_path__ + "img/detail-promotion.d91666fc.png";